"use strict";

var _classCallCheck = require("/home/runner/work/web/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/web/web/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SchedulerError = /*#__PURE__*/function () {
  function SchedulerError(code, message) {
    _classCallCheck(this, SchedulerError);

    this._code = code;
    this._message = message;
  }

  _createClass(SchedulerError, [{
    key: "code",
    get: function get() {
      return this._code;
    }
  }, {
    key: "message",
    get: function get() {
      return this._message;
    }
  }]);

  return SchedulerError;
}();

exports.default = SchedulerError;